// extracted by mini-css-extract-plugin
module.exports = {"main":"Dialog__main--2nDZ2","fieldCommonErrorMessages":"Dialog__fieldCommonErrorMessages--3eG4j"};